import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=234839d8"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports